var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      attrs: {
        sm12: "",
        md12: "",
        layout: "",
        "justify-end": "",
        "align-center": "",
        "mt-3": "",
        "mb-4": ""
      }
    },
    [
      _c(
        "v-btn",
        {
          attrs: { flat: "", small: "", color: "primary" },
          on: { click: _vm.getCSV }
        },
        [
          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
            _vm._v("cloud_download")
          ]),
          _vm._v("\n      \n    "),
          _c("span", { staticClass: "importExportBtnTexto" }, [
            _vm._v("Exportar"),
            _c("br"),
            _vm._v("CSV")
          ])
        ],
        1
      ),
      _vm.dialogPopUp
        ? _c("PopUpGenerateReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }